import { render, staticRenderFns } from "./politics.vue?vue&type=template&id=3d564e2c&scoped=true&"
var script = {}
import style0 from "./politics.vue?vue&type=style&index=0&id=3d564e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d564e2c",
  null
  
)

export default component.exports